export const AVAILABLE_LOCALES = ['en', 'ar']

export const A_B_KEY = 'qic-qatar-travel_flow_ab_state'

export const CDN_URL = 'https://webcdn.static.qic.online'
